import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import LandingPage from './container/landingPage';
import LandingPageCopy from './container/landingPageCopy';

import './App.css';
import InvitationPage from './container/invitation';
import Home from './container/Home';

function App() {
  return (

      <Router>
        <Switch>
           <Route path="/" exact component={LandingPage}/>
           <Route path="/copy" exact component={LandingPageCopy}/>
           <Route path="/invite" exact component={InvitationPage}/>
           
           {
             process.env.NODE_ENV === 'development' &&
             <>
              <Route path="/dashboard" exact component={Home}/>
             </>
           }

           <Route>
             <h2>404 PAGE !!!!!!</h2>
           </Route>
        </Switch>
      </Router>
  );
}

export default App;
